import { Box, Flex, Text } from '@everlywell/ui-kit';
import DynamicIcon from 'components/DynamicIcon';
import { createSharedButtonProps } from 'components/PageSections/utils';
import React from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

export type PricingSelectorModalOptionsProps = {
  title?: string;
  icon?: string;
  description?: string;
  slug?: string;
};

/**
 * [Add the description for what this component does here].
 */
const PricingSelectorModalOptions = ({
  title,
  icon,
  description,
  slug,
}: PricingSelectorModalOptionsProps) => {
  const boxProps = createSharedButtonProps(slug);

  const trackClick = () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_LINK,
      data: {
        sectionHeader: title || 'No title provided',
        contentfulSection: 'Pricing Selector Modal',
      },
    });
  };

  return (
    <Box
      {...boxProps}
      display="flex"
      flexDirection="row"
      alignItems="center"
      padding="4"
      gap="3"
      border="1px solid"
      borderColor="tints.darkCream"
      borderRadius="xl"
      _hover={{
        cursor: 'pointer',
        boxShadow: '0px 4px 35px 0px rgba(0, 0, 0, 0.08)',
      }}
      onClick={trackClick}
    >
      <Flex
        width="40px"
        height="40px"
        backgroundColor="tints.lightCream"
        justifyContent="center"
        borderRadius="full"
      >
        <DynamicIcon
          icon={icon}
          size="lg"
          color="viridian.base"
          width="24px"
          height="24px"
          sx={{
            '&:before': {
              // Icon size
              fontSize: '24px',
            },
          }}
        />
      </Flex>
      <Box flex="1">
        <Text fontSize="xl">{title}</Text>
        <Text fontSize="md" color="tints.darkGrey">
          {description}
        </Text>
      </Box>
    </Box>
  );
};

export default PricingSelectorModalOptions;
